import { SVGAttributes } from 'react'

const id = 'copy-icon'
const CopyIcon = (props: SVGAttributes<SVGElement>) => {
    const gradientId = props.id || id
    const fill = props.className?.includes('--stop-color-1') ? `url(#${gradientId})` : undefined

    return (
        <svg
            width="38"
            height="38"
            viewBox="0 3 38 33"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <defs>
                <linearGradient x1="0%" y1="10%" x2="0%" y2="90%" id={gradientId}>
                    <stop id="gradient-stop-1" offset="0%" stopColor="var(--stop-color-1)" />
                    <stop id="gradient-stop-2" offset="100%" stopColor="var(--stop-color-2)" />
                </linearGradient>
            </defs>
            <path
                fill={fill}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.0909 22.6034V5.78752C34.089 5.15096 33.8169 4.54099 33.3342 4.09087C32.8515 3.64076 32.1973 3.38708 31.5147 3.38525H13.4808C12.7981 3.38708 12.1439 3.64076 11.6612 4.09087C11.1785 4.54099 10.9064 5.15096 10.9045 5.78752V11.1926H23.7858C24.9812 11.1939 26.1271 11.6372 26.9723 12.4253C27.8176 13.2134 28.293 14.282 28.2943 15.3966V25.0057H31.5147C32.1973 25.0038 32.8515 24.7501 33.3342 24.3C33.8169 23.8499 34.089 23.2399 34.0909 22.6034ZM23.5277 12.9943H6.48519C5.06235 12.9943 3.90891 14.0699 3.90891 15.3966V32.2125C3.90891 33.5392 5.06235 34.6147 6.48519 34.6147H23.5277C24.9505 34.6147 26.104 33.5392 26.104 32.2125V15.3966C26.104 14.0699 24.9505 12.9943 23.5277 12.9943Z"
            />
        </svg>
    )
}
export default CopyIcon
